if (!customElements.get('site-search')) {
  class SiteSearch extends HTMLElement {
    constructor() {
      super();
      this.trigger = this.querySelector('[data-site-search-open]');
      this.panel = this.querySelector('[data-site-search-panel]');
      this.closeButton = this.querySelector('[data-site-search-close]');
      this.input = this.querySelector('input[type="search"]');
      this.predictiveSearch = this.querySelector('predictive-search');
      this.predictiveSearchResults = this.querySelector('[data-predictive-search]');

      this.onDocumentClick = this.onDocumentClick.bind(this);
      this.onKeydown = this.onKeydown.bind(this);
      this.onPanelClick = this.onPanelClick.bind(this);
      this.isScrollLocked = false;
    }

    connectedCallback() {
      this.trigger?.addEventListener('click', () => this.open());
      this.closeButton?.addEventListener('click', () => this.close());
      this.panel?.addEventListener('click', this.onPanelClick);
      this.predictiveSearchResults?.addEventListener('click', this.onPanelClick);
    }

    open() {
      document.querySelectorAll('site-search[open]').forEach((search) => {
        if (search !== this) search.close();
      });

      this.setPanelTop();
      this.closeHeaderDropdowns();
      this.panel.hidden = false;
      this.setAttribute('open', '');
      this.trigger?.setAttribute('aria-expanded', 'true');
      document.body.classList.add('site-search-open');
      if (!this.isScrollLocked) {
        lockBodyScroll();
        this.isScrollLocked = true;
      }

      window.requestAnimationFrame(() => this.input?.focus());
      document.addEventListener('click', this.onDocumentClick);
      document.addEventListener('keydown', this.onKeydown);
    }

    close() {
      this.removeAttribute('open');
      this.trigger?.setAttribute('aria-expanded', 'false');
      this.predictiveSearch?.close(false);

      window.setTimeout(() => {
        if (!this.hasAttribute('open')) this.panel.hidden = true;
      }, 180);

      if (!document.querySelector('site-search[open]')) {
        document.body.classList.remove('site-search-open');
      }
      if (this.isScrollLocked) {
        unlockBodyScroll();
        this.isScrollLocked = false;
      }

      document.removeEventListener('click', this.onDocumentClick);
      document.removeEventListener('keydown', this.onKeydown);
    }

    closeHeaderDropdowns() {
      document.querySelectorAll('.header-language-selector__button[aria-expanded="true"]').forEach((button) => {
        button.setAttribute('aria-expanded', 'false');
      });

      document.querySelectorAll('.header-language-selector__list-wrapper:not([hidden])').forEach((panel) => {
        panel.setAttribute('hidden', true);
      });
    }

    setPanelTop() {
      const header = this.closest('.section-header') || document.querySelector('.section-header');
      const panelTop = header ? header.getBoundingClientRect().bottom : 0;
      this.panel.style.setProperty('--site-search-panel-top', `${panelTop}px`);
    }

    onDocumentClick(event) {
      if (this.predictiveSearchResults?.contains(event.target)) return;

      if (!this.contains(event.target)) this.close();
    }

    onPanelClick(event) {
      const clickedEmptyPanel = event.target === this.panel || event.target === this.predictiveSearchResults;

      if (clickedEmptyPanel) this.close();
    }

    onKeydown(event) {
      if (event.code === 'Escape') this.close();
    }
  }

  customElements.define('site-search', SiteSearch);
}
